export const accessToken = state => state.accessToken // APP 传递过来的access_token
export const appInfo = state => state.appInfo // APP相关信息，包括oem信息，token，roleType等相关信息
